import { Link, Typography } from "@mui/material"
import { PageContainer } from "./PageContainer"
import { Footer } from "./Footer"
import { Nav } from "./Nav"

export const Privacy = () => {
  return (
    <>
      <PageContainer>
        <Nav />
        <Typography variant="h1">Privacyverklaring Het Huis Van Vier VOF</Typography>

        <p className="description text-center">
          In deze privacyverklaring informeren wij u over hoe wij omgaan met persoonsgegevens.
        </p>

        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            1. Wie is verantwoordelijk voor de verwerking van uw persoonsgegevens?
          </Typography>
          <p>
            In deze privacyverklaring beschrijft Het Huis Van Vier VOF (hierna “Het Huis Van Vier”
            of “wij”) hoe wij met uw (bijzondere) persoonsgegevens omgaan.
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            2. Welke persoonsgegevens verwerken wij?
          </Typography>
          <p>
            Informatie over een geïdentificeerde of identificeerbare natuurlijke persoon is een
            persoonsgegeven. Het Huis Van Vier verwerkt persoonsgegevens over u, doordat u aanmeldt
            met Smartschool, en doordat u zelf een bestelling plaatst en daarvoor gegevens aan ons
            verstrekt t.b.v. de bestelling.
          </p>
          <p>Bij het inloggen via Smartschool, houden wij volgende gegevens bij van u</p>

          <ul>
            <li>Naam en voornaam</li>
            <li>Type Smartschool account (moeder / vader / ...)</li>
            <li>Naam en voornaam van de leerling</li>
            <li>Geboortedatum van de leerling</li>
          </ul>

          <p>
            Dit zijn de minimale gegevens die Het Huis Van Vier nodig heeft om te zorgen dat u de
            juiste foto&amps;s te zien krijgt bij het inloggen.
          </p>

          <p>Bij het plaatsen van een bestelling hebben wij de volgende gegevens van u nodig:</p>

          <ul>
            <li>Naam en voornaam</li>
            <li>E-mailadres</li>
          </ul>

          <p>
            Deze gegevens worden bewaard bij{" "}
            <Link href="https://stripe.com/nl-be/privacy" rel="nofollow noreferrer" target="_blank">
              Stripe
            </Link>
            .
          </p>

          <p>
            Gegevensverwerking is noodzakelijk voor de uitvoering van de overeenkomst en worden voor
            een duur van maximaal 7 jaar opgeslagen in onze database.
          </p>

          <Typography variant="h3" fontWeight={700}>
            Bijzondere Persoonsgegevens die wij verwerken:
          </Typography>
          <p>
            Wij maken foto’s van leerlingen van en op diverse scholen. Wij hebben geen actieve rol
            in het verwerken van Bijzondere Persoonsgegevens. Echter, doordat op een foto een aantal
            Bijzondere Persoonsgegevens wel interpreteerbaar zijn, zijn er toch een aantal
            Bijzondere Persoonsgegevens die mogelijk door ons verwerkt worden van toepassing,
            namelijk:
          </p>
          <ul>
            <li>Godsdienst of levensovertuiging</li>
            <li>Ras</li>
            <li>Gezondheid</li>
          </ul>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            3. Verwerking van gegevens van personen jonger dan 16 jaar
          </Typography>
          <p>
            Onze website en/of dienst heeft niet de intentie gegevens te verzamelen over
            websitebezoekers die jonger zijn dan 16 jaar. Tenzij ze toestemming hebben van ouders of
            voogd. We kunnen echter niet controleren of een bezoeker ouder dan 16 is. Wij raden
            ouders dan ook aan betrokken te zijn bij de online-activiteiten van hun kinderen, om zo
            te voorkomen dat er gegevens over kinderen verzameld worden zonder ouderlijke
            toestemming. Als u vermoedt dat wij zonder die toestemming persoonlijke gegevens hebben
            verzameld over een minderjarige, neem dan contact met ons op via
            privacy@hethuisvanvier.be. Indien dit het geval is, zullen wij deze informatie
            verwijderen.
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            4. Verwerking: grondslagen en gerechtvaardigde belangen
          </Typography>
          <p>
            De verwerking door Het Huis Van Vier van uw persoonsgegevens, vindt plaats op basis van
            de volgende grondslagen uit de Algemene Verordening Gegevensbescherming:
          </p>
          <ol>
            <li>Toestemming</li>
            <li>Uitvoeren van een overeenkomst met u</li>
            <li>Wettelijke verplichting</li>
            <li>Vervulling van een taak van algemeen belang</li>
          </ol>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            5. Doeleinden voor het verwerken van de persoonsgegevens
          </Typography>
          <p>Het Huis Van Vier verwerkt uw persoonsgegevens, voor de volgende doelen:</p>
          <ul>
            <li>Inloggen en tonen van foto&amps;s van de leerling(en)</li>
            <li>Het afhandelen van uw betaling</li>
          </ul>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            6. Delen met derden
          </Typography>
          <p>
            Het Huis Van Vier verstrekt uitsluitend aan derden en alleen als dit nodig is voor de
            uitvoering van onze overeenkomst met u of om te voldoen aan een wettelijke verplichting.
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            7. In kaart brengen websitebezoek
          </Typography>
          <p>
            Het Huis Van Vier gebruikt alleen technische en functionele cookies en analytische
            cookies die geen inbreuk maken op uw privacy. Een cookie is een klein tekstbestand dat
            bij het eerste bezoek aan onze website wordt opgeslagen op uw computer, tablet of
            smartphone. De cookies die wij gebruiken zijn noodzakelijk voor de technische werking
            van de website en uw gebruiksgemak. Ze zorgen ervoor dat de website naar behoren werkt
            en onthouden bijvoorbeeld uw voorkeursinstellingen. Ook kunnen wij hiermee onze website
            optimaliseren. U kunt zich afmelden voor cookies door uw internetbrowser zo in te
            stellen dat deze geen cookies meer opslaat. Daarnaast kunt u ook alle informatie die
            eerder is opgeslagen via de instellingen van uw browser verwijderen.
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            8. Hoe lang bewaren wij gegevens?
          </Typography>
          <p>
            Wij bewaren persoonsgegevens overeenkomstig de in ons privacy-beleid opgenomen
            bewaartermijnen en/of zo lang als u klant bent bij Het Huis Van Vier. Of de geldende
            wettelijke verplichtingen om gegevens te bewaren. De termijn die wij hanteren is een
            periode van maximaal van 7 jaar, tenzij wettelijke regelgeving anders bepaald.
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            9. Gegevens inzien, aanpassen of verwijderen
          </Typography>
          <p>
            U heeft het recht om te weten welke persoonsgegevens wij van u hebben vastgelegd. U kunt
            een verzoek tot inzage sturen naar privacy@hethuisvanvier.be.
          </p>
          <p>
            Naast het recht op inzage heeft u met betrekking tot onze verwerking van uw
            persoonsgegevens de volgende rechten:
          </p>
          <ul>
            <li>
              Het recht om uw toestemming in te trekken, voor zover onze verwerking van uw
              persoonsgegevens daarop is gebaseerd;
            </li>
            <li>Het recht om een klacht in te dienen bij de Autoriteit Persoonsgegevens;</li>
            <li>Het recht om uw gegevens te (laten) corrigeren;</li>
            <li>Het recht op verwijdering van uw persoonsgegevens;</li>
            <li>Het recht op beperking van de uw betreffende verwerking;</li>
            <li>Het recht op dataportabiliteit;</li>
            <li>Het absolute recht om bezwaar te maken tegen direct marketing;</li>
            <li>
              Het recht om bezwaar te maken tegen verwerkingen die plaatsvinden vanwege
              gerechtvaardigde belangen van Het Huis Van Vier;
            </li>
          </ul>
          <p>
            U kunt uw rechten slechts uitoefenen voor zover de wet deze rechten toekent. Om er zeker
            van te zijn dat het verzoek tot inzage door u is gedaan, vragen wij u een kopie van uw
            identiteitsbewijs bij dit verzoek mee te sturen. Hierbij vragen we u om op deze kopie uw
            pasfoto, de MRZ (machine readable zone: de strook met nummers onderaan het paspoort),
            paspoortnummer en Burgerservicenummer (BSN) onherkenbaar te maken. Dit ter bescherming
            van uw privacy. Het Huis Van Vier zal zo snel mogelijk, maar binnen vier weken, op uw
            verzoek reageren.
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            10. Beveiliging en bescherming van gegevens
          </Typography>
          <p>
            Het Huis Van Vier neemt de bescherming van uw gegevens serieus en neemt passende
            maatregelen om misbruik, verlies, onbevoegde toegang, ongewenste openbaarmaking en
            ongeoorloofde wijziging tegen te gaan. Deze beveiligingsmaatregelen worden periodiek
            herzien en indien nodig aangepast. Als u de indruk heeft dat uw gegevens niet goed
            beveiligd zijn of er zijn aanwijzingen van misbruik, neem dan contact op met onze
            klantenservice via info@hethuisvanvier.be.
          </p>
          <p>
            Het Huis Van Vier heeft de volgende maatregelen genomen om uw persoonsgegevens te
            beveiligen:
          </p>
          <ul>
            <li>Beveiligingssoftware, zoals een virusscanner en firewall.</li>
            <li>
              TLS (voorheen SSL) Wij versturen uw gegevens via een beveiligde internetverbinding.
              Dit kunt u zien aan de adresbalk ‘https’ en het hangslotje in de adresbalk.
            </li>
            <li>
              DKIM, SPF en DMARC zijn drie internetstandaarden die wij gebruiken om te voorkomen dat
              u uit onze naam e-mails ontvangt die virussen bevatten, spam zijn of bedoeld zijn om
              persoonlijke (inlog)gegevens te bemachtigen.
            </li>
          </ul>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            11. Het Huis Van Vier – verwerker of verwerkingsverantwoordelijke
          </Typography>
          <p>
            Het Huis Van Vier maakt in opdracht van haar opdrachtgevers (scholen, instanties,
            bedrijven) foto’s die bijvoorbeeld voor schooldoeleinden gebruikt worden. De gemaakte
            foto’s worden door Het Huis Van Vier eventueel online geplaatst of de opdrachtgever
            voert een handeling uit zodat de foto’s ter beschikking worden gesteld aan de
            ouders/verzorgers of betrokkenen. De werkwijze van Het Huis Van Vier wordt vooraf met
            haar opdrachtgever besproken en voert deze namens de opdrachtgever uit. Indien een
            ouder/verzorger of betrokkenen wenst een bestelling te plaatsen, gaan zij akkoord met de
            algemene voorwaarden van Het Huis Van Vier. Er vindt dan zonder tussenkomst van de
            opdrachtgever een overeenkomst plaats tussen ouder/verzorger/ of betrokkene en Het Huis
            Van Vier. Het Huis Van Vier wordt dan de verwerkingsverantwoordelijke.
          </p>
          <p>
            Gegevensverwerkingen zijn noodzakelijk om het gerechtvaardigd belang van Het Huis Van
            Vier te kunnen waarborgen.
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            12. Contact
          </Typography>
          <p>
            Voor vragen en/of opmerkingen met betrekking tot deze privacyverklaring kunt u contact
            opnemen met:
          </p>
          <p>
            Het Huis Van Vier VOF
            <br />
            Meester Richard Goossensstraat 27
            <br />
            2650 Edegem
            <br />
            Tel. 03 345 67 83
            <br />
            <Link href="http://www.hethuisvanvier.be" target="_blank">
              www.hethuisvanvier.be
            </Link>
          </p>
        </div>
        <div className="block-privacyverklaring">
          <Typography variant="h2" fontWeight={700}>
            13. Wijzigingen
          </Typography>
          <p>
            De manier waarop wij persoonsgegevens verwerken kan mogelijk in de toekomst wijzigen.
            Daarom behouden wij ons het recht voor deze privacyverklaring aan te passen, indien dit
            aan de orde is. U wordt indien nodig op de hoogte gebracht van een wijziging.
          </p>
        </div>

        <Typography variant="body2" sx={{ mb: 8 }}>
          Versie: februari 2022
        </Typography>
      </PageContainer>
      <Footer />
    </>
  )
}
